import { memo } from 'react';

import { FileStatusIconErrored, FileStatusSubtitle, FileStatusTitle } from '@air/feature-file-status/ui';

import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { type ClipVideoTaskMetadata } from '~/components/VideoClipTasks/types';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type VideoClipTaskPanelItemFailedProps = {
  metadata: ClipVideoTaskMetadata;
  onClear: () => void;
};

const getVideoClipFailedSubtitle = (isAssetVersion: boolean) =>
  isAssetVersion ? 'Unable to create new version. Please try again.' : 'Unable to create new asset. Please try again.';

export const VideoClipTaskPanelItemFailed = memo(({ metadata, onClear }: VideoClipTaskPanelItemFailedProps) => {
  const { ui2026 } = useTemporaryFeatureFlags();
  const isAssetVersion = metadata?.saveResultAs?.as === 'assetVersion';

  return (
    <PaneItemTW
      avatar={<FileStatusIconErrored size={getTaskPaneFileStatusIconSize(ui2026)} />}
      title={
        <FileStatusTitle data-testid="VIDEO_CLIP_PANEL_FAILED_TITLE">
          {ui2026 ? 'Couldn’t save clip' : 'Error saving video'}
        </FileStatusTitle>
      }
      subtitle={
        ui2026 ? undefined : (
          <FileStatusSubtitle className="truncate">{getVideoClipFailedSubtitle(isAssetVersion)}</FileStatusSubtitle>
        )
      }
      buttons={<TaskPaneDismissButton label="Dismiss" onClick={onClear} />}
    />
  );
});

VideoClipTaskPanelItemFailed.displayName = 'VideoClipTaskPanelItemFailed';
